import { useStore } from '@/store/Store'
import DefaultLayout from './layout/DefaultLayout'
import { Navigate, Outlet } from 'react-router-dom'

const ProtectedRoute = () => {
  const {
    state: { userInfo },
  } = useStore()

  if (userInfo) {
    return (
      <DefaultLayout>
        <Outlet />
      </DefaultLayout>
    )
  } else {
    return <Navigate to='/login' />
  }
}

export default ProtectedRoute
